module.exports = __webpack_public_path__ + "5bc48124b963e31ad6db664492c8d8f0.svg";